import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import PhotoSwipeLightbox from 'photoswipe/lightbox';
import PhotoSwipe from 'photoswipe';
import 'photoswipe/style.css';
import Image from './Image';

export default function Images(props) {
  const { images, className, imageHeight, imageChild } = props;

  const [galleryId] = useState(`g-${crypto.randomUUID()}`);

  useEffect(() => {
    let lightbox = new PhotoSwipeLightbox({
      gallery: `#${galleryId}`,
      children: 'a',
      // pswpModule: () => import('photoswipe')
      pswpModule: PhotoSwipe
    });
    lightbox.init();

    return () => {
      lightbox.destroy();
      lightbox = null;
    };
  }, []);

  return (
    <div id={galleryId} className={className}>
      {images.data.map(function(image) {
        return (
          <Image
            key={image.id}
            image={image}
            imageHeight={imageHeight}
            imageChild={imageChild}
          />
        );
      })}
    </div>
  );
};

Images.propTypes = {
  images: PropTypes.shape({
    data: PropTypes.array.isRequired
  }).isRequired,
  className: PropTypes.string,
  imageHeight: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number
  ]),
  imageChild: PropTypes.node
};
